module.exports = __webpack_public_path__ + "static/media/canTakeMost.9f7b060f.mp3";